import { Show } from "shared/components";
import { VerifiedIncomeReport } from "types/landlord/reports";
import { CreditCard01, Home02 } from "untitledui-js-base";
import { formatToCurrency } from "utils/currency";
import { Section } from "views/applications-id-report/components/Section";
import { RoundedMathSymbol } from "views/applications-id/components/ApplicationMonthlyRentCard/components/RoundedMathSymbol";

interface ProjectedDebtincomeRatioProps {
  report?: VerifiedIncomeReport;
}

export const ProjectedDebtIncomeRatio = ({
  report
}: ProjectedDebtincomeRatioProps) => {
  return (
    <Section sectionTitle="Projected debt to income ratio" maxWidth="none">
      <div className="flex md:flex-row flex-col gap-y-2 w-full justify-between items-center py-8">
        <div className="flex md:flex-col gap-x-2">
          <p className="text-content-1000 font-medium">Monthly debt</p>
          <p className="text-content-300 font-medium md:text-left text-center">
            {report?.total_monthly_debt?.cents
              ? formatToCurrency({
                  cents: report.total_monthly_debt.cents,
                  currency: "USD"
                })
              : "N/A"}
          </p>
        </div>

        <RoundedMathSymbol symbol="/" />
        <div className="flex md:flex-col gap-x-2">
          <p className="text-content-1000 font-medium">Net monthly income</p>
          <p className="text-content-300 md:text-left text-center">
            {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
            {report?.net_monthly_income?.cents
              ? formatToCurrency({
                  cents: report.net_monthly_income.cents,
                  currency: "USD"
                })
              : "N/A"}
          </p>
        </div>

        <RoundedMathSymbol symbol="X" />

        <p className="text-content-1000 font-medium md:text-left text-center">
          100
        </p>

        <RoundedMathSymbol symbol="=" />

        <div className="flex md:flex-col gap-x-2">
          <p className="text-content-1000 font-medium">Debt to income ratio</p>
          <p className="text-content-300 font-medium  md:text-left text-center">
            {report?.debt_income_ratio ? `${report.debt_income_ratio}%` : "N/A"}
          </p>
        </div>
      </div>

      <div className="mt-4">
        <p className="text-content-1000 font-medium mb-7">
          Monthly debt includes
        </p>

        <Show if={report?.debts ? report.debts.length > 0 : false}>
          <div className="flex gap-4 flex-col">
            {report?.debts.map((debt) => {
              return (
                <div
                  className="flex justify-between"
                  key={debt.name + debt.amount}
                >
                  <div className="flex gap-3 items-center">
                    {debt.name === "listed_rent_amount" ? (
                      <Home02 className="shrink-0 stroke-content-400" />
                    ) : (
                      <CreditCard01 className="shrink-0 stroke-content-400" />
                    )}

                    <div className="flex flex-col">
                      <p className="text-content-400 font-medium first-letter:uppercase">
                        {debt.name.replaceAll("_", " ") || "-"}
                      </p>
                      <p className="text-content-400 font-normal">
                        {debt.description || "-"}
                      </p>
                    </div>
                  </div>

                  <div>
                    <p className="text-content-1000 font-medium">
                      {formatToCurrency({
                        cents: debt.amount.cents,
                        currency: "USD"
                      })}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </Show>
      </div>
    </Section>
  );
};
